import { render, staticRenderFns } from "./DocumentOrderAdminModal.vue?vue&type=template&id=39790c12&scoped=true"
import script from "./DocumentOrderAdminModal.vue?vue&type=script&lang=js"
export * from "./DocumentOrderAdminModal.vue?vue&type=script&lang=js"
import style0 from "./DocumentOrderAdminModal.vue?vue&type=style&index=0&id=39790c12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39790c12",
  null
  
)

export default component.exports